"use strict";

function PollingTimer(length, action) {
  this._interval = null;
  this._count = 0;
  this._timeLimitInSeconds = length;
  this._action = action;
  this._timeout = null;

  this.start = function () {
    this.performAction();
    this._interval = setInterval(this._iterate.bind(this), 1000);
  };

  this.stop = function () {
    if (this._interval) clearInterval(this._interval);
    if (this._timeout) clearTimeout(this._timeout);
    this._count = this._timeLimitInSeconds;
  };

  this.isActive = function () {
    return this._count < this._timeLimitInSeconds;
  };

  this.performAction = function () {
    this._timeout = setTimeout(this._action, 3000);
  };

  this._iterate = function () {
    if (this._count <= this._timeLimitInSeconds) {
      return this._count += 1;
    }

    clearInterval(this._interval);
  };
}